import { Injectable } from "@angular/core";
import { SingleRunResolver } from "./single-run.resolver";
import { SharedInitService } from "./shared-init.service";

@Injectable({ providedIn: 'root' })
export class MyTrackInitResolver extends SingleRunResolver {

  constructor(private readonly sharedInitService: SharedInitService) {
    super();
  }

  protected runOnce() {
    this.sharedInitService.initRagMatrix();
    this.sharedInitService.getAutoUpdates();
  }
}
